/* eslint-disable jsx-a11y/img-redundant-alt */

/// Componente encargado de mostrar el contenido de las tabs ///
// import { useContext } from "react";

import { Link } from "react-router-dom";
import "./SliderEventsContent.css";
import useWindowWidth from "../../hooks/useWindowWidth";
// import { I18nContext } from "../../context/I18nProvider";

import { LocationIcon } from "../icons/index";

import SliderImage from "../../assets/images/static/slider__events.png";

const SliderEventsContent = ({ active, index, content }) => {
  const width = useWindowWidth(); // Hook para detectar el ancho de la pantalla

  // const { language } = useContext(I18nContext);

  return (
    <div
      key={index}
      className="sliderEvents__content"
      style={active === index ? { display: "flex" } : { display: "none" }}
    >
      <div className="sliderEvents__content__text">
        <h2>
          {content.date.month} <br /> <span>{content.date.year}</span>
        </h2>

        <h3>{content.title}</h3>

        <p>
          {width < 992
            ? content.info.slice(0, 80) + "..."
            : content.info.split(" ").slice(0, 42).join(" ")}
        </p>

        <small>
          <LocationIcon /> {content.location}
        </small>
        <div className="btn-container-actions">        
          {content.brochure && <div className="btn-pdf">
          <a href={content.brochure} target="_blank" rel="noopener noreferrer" >Ver PDF</a>
          
        </div>}

        <div className="btn-seemore">
          {
            content.link.internal
              ? <Link to={`${content.link.url}`}>{content.link.text}</Link>
              : <a href={content.link.url} target="_blank" rel="noopener noreferrer">{content.link.text}</a>
          }

        </div>

        </div>
      </div>

      <div className="sliderEvents__content__image">
        <div className="sliderEvents__content__overlay"></div>
        <img
          src={content.image === "" ? SliderImage : content.image}
          alt={content.title}
          title={content.title}
        />
      </div>
    </div>
  );
};

export default SliderEventsContent;